export default "__VITE_ASSET__sTg7rTW2__ 1600w, __VITE_ASSET__HP1loSYP__ 800w";